module.exports = __webpack_public_path__ + "static/media/device-mockup-mobile.b9ca164d.png";